import React, { useState } from 'react';
import '../styles/Navbar.css';
import logo from '../assets/logo.png';
import { FaUser  } from 'react-icons/fa';
import SignupModal from "../components/SignupModal";

const Navbar = () => {
  const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);
  return (
    <nav className="navbar">
      <img src={logo} alt="Logo" className="logo" />
      <button className="signup-btn" onClick={() => setIsSignupModalOpen(true)}>
        <FaUser  style={{ marginRight: '6px' }} />
        Sign In
      </button>

      <SignupModal isOpen={isSignupModalOpen} onClose={() => setIsSignupModalOpen(false)} />
    </nav>
  );
};

export default Navbar;
